export const EvaluationInfoEnum = {
EvaluationStepInfo: "EvaluationStepInfo",
EvaluationInfo: "EvaluationInfo",
ourLawInfo: "ourLawInfo",
updateConnectionInfo: "updateConnectionInfo"
};

export const EvaluationInfoType = Object.values(EvaluationInfoEnum);